export default {"src":"/_next/static/media/coupon.d8a530e4.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};